import { render } from "./ProjetoDeVida.vue?vue&type=template&id=5059f7c6&scoped=true"
import script from "./ProjetoDeVida.vue?vue&type=script&lang=js"
export * from "./ProjetoDeVida.vue?vue&type=script&lang=js"

import "./ProjetoDeVida.vue?vue&type=style&index=0&id=5059f7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5059f7c6"]])

export default __exports__